import NextLink from "next/link";
import type { ComponentProps } from "react";

/**
 * next/link with prefetch disabled by default.
 *
 * Googlebot renders pages and executes the viewport prefetch for every link in
 * a grid, so ~28% of our crawl budget was going to RSC/JSON payloads instead of
 * HTML (Search Console, Sep 2026). Pass prefetch={true} to opt back in for a
 * specific link.
 */
export default function Link({ prefetch = false, ...props }: ComponentProps<typeof NextLink>) {
  return <NextLink prefetch={prefetch} {...props} />;
}
